import { push, get } from 'firebase/database';

// Audit trail for generated driver letters. Every time a verification or
// clearance letter is produced from the dashboard we push one slim record to
// RTDB (/driver_letters) capturing WHO generated WHAT for WHICH driver, WHEN,
// and the key parameters — enough to reconcile an issued physical letter and
// spot fraud, without storing the (heavy) rendered PDF itself.

export const saveLetterRecord = async (firebase, record) => {
  if (!firebase || !firebase.driverLettersRef) return;
  try {
    await push(firebase.driverLettersRef, record);
  } catch (error) {
    // Logging must never block the letter from being handed to the user —
    // surface to console only.
    console.error('Failed to save driver letter record:', error);
  }
};

// One-shot read (get, not a live listener) for the audit table — fetched on
// demand when the Records tab opens, sorted newest-first.
export const fetchLetterRecords = async (firebase) => {
  if (!firebase || !firebase.driverLettersRef) return [];
  const snap = await get(firebase.driverLettersRef);
  const val = snap.val();
  if (!val) return [];
  return Object.keys(val)
    .map((id) => ({ id, ...val[id] }))
    .sort((a, b) => (b.generatedAt || 0) - (a.generatedAt || 0));
};
